export default "__VITE_ASSET__CQw3ovi4__"